import React, {Component} from "react";
import {GoogleApiWrapper, Map, Marker} from "google-maps-react";
import {map, isEmpty} from "lodash";

class CustomMap extends Component {
  state = {
    markers: this.props.markers
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (!isEmpty(nextProps?.markers) && JSON.stringify(nextProps?.markers) !== JSON.stringify(this.state.markers)) {
      this.setState({markers: nextProps?.markers})
    }
  }

  shouldComponentUpdate = (nextProps) => {
    return JSON.stringify(nextProps?.markers) !== JSON.stringify(this.state.markers);
  }

  render() {
    const {containerStyle, zoom} = this.props;
    const {markers} = this.state;

    return (
      <Map google={this.props.google} zoom={zoom ? zoom : 8} disableDefaultUI={true}
        containerStyle={{position: 'relative', width: '100%', height: '120px', ...containerStyle}}
        initialCenter={{lat: markers?.[0]?.lat, lng: markers?.[0]?.lng}}>
        {map(markers, (obj, index) => {
          return <Marker
            onClick={() => (this.props.onMarkerClick && (index === 0 || index === 2)) ? this.props.onMarkerClick(index) : null}
            key={`Marker${index}`}
            index={index}
            position={{lat: obj?.lat, lng: obj?.lng}}
            label={`${index + 1}`}/>
        })}
      </Map>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: process.env.REACT_APP_GOOGLE_PLACE_API_KEY
})(CustomMap)